import { useEffect, useState } from "react";
import axios from "axios";

export function resolveAuthImageUrl(imageUrl, backendUrl, pageOrigin) {
  if (typeof imageUrl !== "string" || !imageUrl) return null;

  if (imageUrl.startsWith("/") && !imageUrl.startsWith("//")) {
    return backendUrl ? `${backendUrl}${imageUrl}` : imageUrl;
  }

  try {
    const parsedImageUrl = new URL(imageUrl);
    const trustedOrigin = new URL(backendUrl || pageOrigin).origin;
    const isHttp = ["http:", "https:"].includes(parsedImageUrl.protocol);
    return isHttp && parsedImageUrl.origin === trustedOrigin ? imageUrl : null;
  } catch (_error) {
    return null;
  }
}

// Fetch an authenticated image as a blob and expose an objectURL <img> can use.
// Replaces the inline pattern duplicated in ImageMessage.js and
// BDVersionsPanel.js/ThumbnailImage. The objectURL is revoked on cleanup
// so we don't leak blob refs across mounts.
export function useAuthImage(imageUrl, token) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!imageUrl) return undefined;
    let alive = true;
    let revokeUrl = null;
    const fullUrl = resolveAuthImageUrl(
      imageUrl,
      process.env.REACT_APP_BACKEND_URL,
      window.location.origin,
    );
    if (!fullUrl) {
      setError("Image URL origin is not allowed");
      return undefined;
    }
    setError(null);
    axios
      .get(fullUrl, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        responseType: "blob",
      })
      .then((r) => {
        if (!alive) return;
        revokeUrl = URL.createObjectURL(r.data);
        setSrc(revokeUrl);
      })
      .catch((e) => {
        if (alive) setError(e?.message || "load error");
      });
    return () => {
      alive = false;
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
    };
  }, [imageUrl, token]);

  return { src, error };
}
